import { useBulkCheckpointUpload } from '@/pages/Business/pages/BatchCheckpoints/hooks/BulkUpload/useBulkCheckpointUpload';
import { useGetExternalOperatorBatchTransitionsQuery } from '../../services/externalOperatorBatchTransitions.endpoints';

export const useExternalOperatorBulkCheckpointUpload = () =>
  useBulkCheckpointUpload({
    useTransitionsQuery: useGetExternalOperatorBatchTransitionsQuery,
  });
